class AssistantIntegrations {

  constructor(basePath, apiClient) {

    this.apiClient = apiClient;
    this.basePath = `${basePath}/assistant-integrations`;

  }

  getAssistantIntegrations() {

    const path = `${this.basePath}`;

    return this.apiClient.get(path, {}, {});

  }

  connectAssistantIntegration(data) {

    const path = `${this.basePath}/connect`;

    return this.apiClient.post(path, {}, {}, data);

  }

  disconnectAssistantIntegration(integrationId) {

    const path = `${this.basePath}/:integrationId/disconnect`;

    return this.apiClient.post(path, { integrationId }, {}, {});

  }

  getAssistantIntegrationStatus(integrationId) {

    const path = `${this.basePath}/:integrationId/status`;

    return this.apiClient.get(path, { integrationId }, {});

  }

  getAssistantIntegrationTools(integrationId) {

    const path = `${this.basePath}/:integrationId/tools`;

    return this.apiClient.get(path, { integrationId }, {});

  }

}

export default AssistantIntegrations;
